import { copilotWorkingLabel } from "../../lib/copilot-tool-labels";

// Single, continuously-mounted "working" affordance for the copilot dock
// (SILL-459). It replaces the old dots-bubble ↔ shimmer-box toggling that
// flickered and left blank gaps across a multi-tool turn: this stays mounted
// for the whole pre-text phase (so nothing mounts/unmounts between tool calls),
// fades in once, and shows a soft, contextual label at lower opacity that
// updates as the copilot moves between tools. `toolName` is the store's
// currentToolName ("" = awaiting the first token → "Thinking…").
export function CopilotThinking({ toolName }: { toolName: string }) {
  const label = copilotWorkingLabel(toolName);
  return (
    <div
      data-testid="copilot-thinking"
      role="status"
      aria-label={`${label}…`}
      className="copilot-msg-enter mr-auto flex items-center gap-2 text-fg-muted"
    >
      <span className="flex items-center gap-1" aria-hidden>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="copilot-typing-dot size-1.5 rounded-full bg-muted-foreground/70"
          />
        ))}
      </span>
      {/* Keyed by label so a tool change cross-fades the copy instead of
          snapping. */}
      <span key={label} className="copilot-label-swap text-sm">
        {label}…
      </span>
    </div>
  );
}
